// middleware/04.first-login.global.ts
//
// Redirects an admin on their first login (or any visit while the clinic
// onboarding checklist is incomplete) to /onboarding.
// Once the admin dismisses the onboarding flow, the cookie
// `onboarding_dismissed_<clinic_id>` is set to '1' and this gate skips.

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/onboarding')) return
  if (to.path.startsWith('/auth'))       return
  if (to.path.startsWith('/admin'))      return
  if (to.path === '/login')              return

  const profile = useState<any>('profile')
  if (!profile.value) return
  if (profile.value.role !== 'admin') return

  const dismissedCookie = useCookie<string | null>(
    `onboarding_dismissed_${profile.value.clinic_id}`
  )
  if (dismissedCookie.value === '1') return

  const supabase = useSupabaseClient()
  const { data } = await supabase
    .from('clinic_onboarding_checklist')
    .select('items')
    .eq('clinic_id', profile.value.clinic_id)
    .single()

  if (!data) return
  const items   = (data.items ?? []) as Array<{ done: boolean }>
  const allDone = items.length > 0 && items.every(i => i.done)

  if (items.length > 0 && !allDone) {
    return navigateTo('/onboarding')
  }
})
